import { AdjustmentNoteCategoryEnum, AdjustmentNoteStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("adjustment_notes")
export class AdjustmentNotesEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"adjustment_notes_id"
    }) 
    adjustmentNotesId: number;

    @Column('enum',{
        name:'category',
        enum:AdjustmentNoteCategoryEnum,
        nullable:false
    })
    category:AdjustmentNoteCategoryEnum

    @Column('int',{
        name:'vendor_id',
        nullable:false
    })
    vendorId:number

    @Column('varchar',{
        name:'debit_note_no',
        nullable:true,
        length:50
    })
    debitNoteNumber:string

    @Column('varchar',{
        name:'credit_note_no',
        nullable:true,
        length:50
    })
    creditNoteNumber:string

    @Column('varchar',{
        name:'invoice_no',
        nullable:false,
        length:50
    })
    invoiceNumber:string

    @Column('int',{
        name:'po_id',
        nullable:false,
    })
    poId:number

    @Column('int',{
        name:'item_id',
        nullable:false,
    })
    itemId:number

    @Column('decimal',{
        name:'price',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    price:number

    @Column('decimal',{
        name:'quantity',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    quantity:number

    @Column('decimal',{
        name:'tax_amount',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    taxAmount:number

    @Column('decimal',{
        name:'total_amount',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    totalAmount:number

    @Column('enum',{
        name:'status',
        nullable:false,
        enum:AdjustmentNoteStatusEnum
    })
    status:AdjustmentNoteStatusEnum

    @Column('int',{
        name:'grn_item_id',
        nullable:false,
    })
    grnItemId:number

    @Column('int',{
        name:'grn_id',
        nullable:false,
    })
    grnId:number

    @Column('decimal',{
        name:'tax_percentage',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    taxPercentage:number

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    
}